import { memo } from 'react'

import { useNavigate } from 'react-router-dom'

import { Section } from '@factorialco/deprecated-design-system'
import { F0Box, F0Button, F0Text } from '@factorialco/f0-react'
import { SecuritySettingsDomainSectionFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  domains: SecuritySettingsDomainSectionFragment[]
}

function BulkEmailChangeSection({ domains }: Props) {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const verifiedDomains = domains.filter((d) => d.status === 'verified')
  const formatter = new Intl.ListFormat(i18n.locale, {
    style: 'long',
    type: 'disjunction',
  })
  const domainList = formatter.format(verifiedDomains.map((d) => `@${d.domainName}`))

  return (
    <Section.TwoThirds
      illustration={undefined}
      title={i18n.t('security_settings.bulk_email_change.title')}
      description={i18n.t('security_settings.bulk_email_change.description')}
    >
      <F0Box display="flex" flexDirection="column" gap="md">
        {verifiedDomains.length > 0 && (
          <F0Text
            variant="description"
            content={i18n.t('security_settings.bulk_email_change.verified_domains_hint', {
              domains: domainList,
            })}
          />
        )}
        <F0Box display="flex" flexDirection="row">
          <F0Button
            label={i18n.t('security_settings.bulk_email_change.action')}
            onClick={() => navigate(navigation.settings.security.bulkEmailChange.fullPath())}
            disabled={verifiedDomains.length === 0}
          />
        </F0Box>
      </F0Box>
    </Section.TwoThirds>
  )
}

export default memo(BulkEmailChangeSection)
